module.exports = "/static-assets/_next/static/images/counting-steps-b1912fd587f65be0749ae0531de5faae.png";